/*
"wkis_identity": {
    "role_type_description": "personal",
    "status": "init"
},
role_type_description: 'personal', 'member'
status: 'init', 'registered', 'organization_required'
init - це на сторінку прайвесі полісі треба редіректити
organization_required - це на сторінку створення оргінізації
registered - кінцевий статус
*/

import axiosApi from '@/plugins/api.js'
import getHttpErrorMessage from '@/utils/http-error-message.js'

const state = {
  isAttemptsLeftWasIncremented: false,
}

const getters = {
  wkisIdentity: (_state, _getters, _rootState, rootGetters) => {
    return rootGetters['account/currentUser']?.wkis_identity
  },

  wkisRole: (_state, getters) => {
    return getters.wkisIdentity?.role_type_description
  },

  isWkisRolePersonal: (_state, getters) => {
    return getters.wkisRole === 'personal'
  },

  isWkisRoleOwner: (_state, getters) => {
    return getters.wkisRole === 'member'
  },

  wkisStatus: (_state, getters) => {
    return getters.wkisIdentity?.status
  },
  shouldUserRedirectToTermsAndConditions: (_state, getters) => {
    return getters.wkisStatus === 'init'
  },
  shouldUserRedirectToCompanyRegistration: (_state, getters) => {
    return (
      getters.isWkisRoleOwner && getters.wkisStatus === 'organization_required'
    )
  },

  shouldUserRedirectToInvitations: (state, getters) => {
    return getters.wkisStatus === 'invited'
  },

  signinWkisWarning: (_state, _getters, _rootState, rootGetters) => {
    return rootGetters['account/currentUser']?.show_wkis_warning
  },

  wkisWarningExpired: (_state, _getters, _rootState, rootGetters) => {
    return rootGetters['account/currentUser']?.wkis_warning_expired
  },

  wkisWarningAttemptsLeft: (_state, _getters, _rootState, rootGetters) => {
    return rootGetters['account/currentUser']?.wkis_warning_attempts_left
  },

  signinWkisError: (_state, getters) => {
    return (
      getters.wkisWarningAttemptsLeft < 1 &&
      !getters.wkisWarningExpired &&
      getters.signinWkisWarning
    )
  },

  showSigninWkisWarningModal: (_state, getters) => {
    return (
      getters.wkisWarningAttemptsLeft > 0 &&
      !getters.wkisWarningExpired &&
      getters.signinWkisWarning
    )
  },

  showSigninWkisWarningLabel: (_state, getters) => {
    return (
      getters.wkisWarningAttemptsLeft > 0 &&
      !getters.wkisWarningExpired &&
      (getters.isAttemptsLeftWasIncremented || !getters.signinWkisWarning)
    )
  },
}

const actions = {
  incrementAttemptsLeft({ commit }) {
    axiosApi
      .patch('/wkis/warning/increment')
      .then(() => {
        commit('updateIsAttemptsLeftWasIncremented', true)
      })
      .catch((error) => {
        const message = getHttpErrorMessage(error)
        this.toast.error(message)
      })
  },
}

const mutations = {
  updateIsAttemptsLeftWasIncremented(state, value) {
    state.isAttemptsLeftWasIncremented = value
  },
}

export const wkis = {
  namespaced: true,
  getters,
  actions,
  state,
  mutations,
}
